// extracted by mini-css-extract-plugin
module.exports = {"decoratorParagraph":"decorator-paragraph_decoratorParagraph__1_jsY"};